var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"pb-50"},[_c('h5',[_vm._v(" Filtros ")])]),_c('b-card-body',[_c('b-row')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }